import { Skeleton } from '../../../../Skeleton'
import { APPLICANT_STAGE_SCREENING_SKELETON_GROUP_ROW_COUNT } from '../RentalPortalApplicantProfileWidgetStageScreening.constants'

import * as styles from './ApplicantProfileWidgetStageScreeningSkeleton.module.css'

function ApplicantProfileWidgetStageScreeningSkeleton() {
  return (
    <div className={styles.ApplicantProfileWidgetStageScreeningSkeleton}>
      <Skeleton className={styles.stage} />
      {APPLICANT_STAGE_SCREENING_SKELETON_GROUP_ROW_COUNT.map(
        (rowCount, groupIndex) => (
          <div className={styles.group} key={groupIndex}>
            <Skeleton className={styles.groupTitle} />
            <div className={styles.checks}>
              {Array.from({ length: rowCount }).map((_, index) => (
                <div className={styles.row} key={index}>
                  <Skeleton className={styles.marker} />
                  <Skeleton className={styles.label} />
                </div>
              ))}
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default ApplicantProfileWidgetStageScreeningSkeleton
